<script setup lang="ts">
import { onMounted, onUnmounted } from "vue";
import { Keyboard } from "@capacitor/keyboard";

import SocketManager from "@/Components/Extend/TcSocketManager.vue";

import useAppStore from "@/Modules/App/Store";

import { log } from "@/Utils/Debug";
import { isApp, isIosApp } from "@/Utils/Ionic";
import { hasValue } from "@/Utils/Objects";

const appStore = useAppStore();

const BOTTOM_SPACE_OFFSET = 16;

const updateHeight = (num?: number) => {
  if (isIosApp()) {
    return;
  }

  let newHeight = isApp() ? window.outerHeight : window.innerHeight;

  if (hasValue(num) && Number.isInteger(num) && !Number.isNaN(num)) {
    newHeight -= num + BOTTOM_SPACE_OFFSET;
  }

  document.body.style.setProperty("--app-height", `${newHeight}px`);
  document.getElementById("app")?.style.setProperty("height", `${newHeight}px`);
};

onMounted(async () => {
  if (isApp()) {
    Keyboard.addListener("keyboardDidShow", (info) => {
      log("keyboard will show with height:", info.keyboardHeight);
      appStore.updateKeyboardStatus(true);
      updateHeight(info.keyboardHeight);
    });

    Keyboard.addListener("keyboardDidHide", () => {
      log("keyboard will show with height:");
      appStore.updateKeyboardStatus(false);
      updateHeight();
    });
  } else {
    appStore.updateKeyboardStatus(false);
  }
});

onUnmounted(() => {
  if (isApp()) {
    Keyboard.removeAllListeners();
  }
});
</script>

<template>
  <SocketManager>
    <slot />
  </SocketManager>
</template>
